import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import history from './History';

class Provacy extends Component {
  render() {
    return (
      <div>
        <div className="docs-title">
          <h1>Megadigm<span className="trademark">&reg;</span> Privacy Policy</h1>
        </div>
        <div className="docs-content"><b>Last Updated:</b> 03/08/2026</div>
        <div className="docs-content">
          <p>
            Megadigm<span className="trademark">&reg;</span> ("we," "our," or "us") operates megadigm.net website and Megadigm<span className="trademark">&reg;</span> webservices (the "Service").
            This Privacy Policy explains how we handle data when you use our services.
          </p>
          <p>
            Because we provide a B2B service, we prioritize data minimization. We do not collect unnecessary personally identifiable information (PII) or financial data (PCI). 
          </p>
          <h2 id="datawecollect">Data We Collect</h2>
          <p>
            We collect only the minimum data necessary to provide our services and for legitimate business purposes:
          </p>
          <h3 id="bizcontact">Business Contact Information</h3>
          <p>
            Name, email address, and company billing address provided during account creation.
          </p>
          <h3 id="sessioncookies">Session Cookies</h3>
          <p>
            We use session cookies to keep you logged in and to track your navigation within the web application during a single visit. These are deleted when the session ends/expires.
          </p>
          <h3 id="usagedata">Usage Metering Data (Non-PII)</h3>
          <p>
            We collect statistics regarding feature usage (e.g., number of API calls, data volume processed, reports generated, pages visited) to calculate billing, monitor system performance, and for tax audit purposes.
            These data are anonymized and not linked to specific individuals.
          </p>
          <h3 id="techlogdata">Technical Audit Logs</h3>
          <p>
            System logs, including IP addresses, timestamps, and request methods, to ensure service security, integrity, and for troubleshooting.
          </p>
          
          <h2 id="howdataused">How We Use Your Data</h2>
          <p>
            We use the collected information for the following, strictly necessary purposes:
          </p>
          <ul className="docs-list">
            <li><b>To provide the Service:</b> Enabling login, user authentication, and core functionality.</li>
            <li><b>To calculate usage-based billing:</b> Determining fees based on service consumption.</li>
            <li><b>For legal and tax compliance:</b> Maintaining records for auditing purposes.</li>
          </ul>
          
          <h2 id="datanotcollected">Data We Do Not Collect</h2>
          <ul className="docs-list">
            <li><b>No PII:</b> We do not collect names, addresses, or identifiers of your end-users or employees.</li>
            <li><b>No PCI:</b> We do not store credit card numbers or banking information. All financial transactions are processed securely through our third-party payment processor.</li>
          </ul>
          
          <h2 id="datasharing">Data Sharing and Disclosure</h2>
          <p>
            We do not sell, rent, or trade your data. We may share data only under the following circumstances:
          </p>
          <h3 id="serviceproviders">Service Providers</h3>
          <p>We may use trusted third-party services (e.g., cloud hosting, and payment processing) that have strict data protection agreements to process data on our behalf.</p>
          <h3 id="serviceproviders">Legal Obligations</h3>
          <p>We may disclose data if required by law, subpoena, or to enforce our service agreement.</p>
          
          <h2 id="datasecurity">Data Security</h2>
          <p>
            We implement industry-standard security measures, including encryption in transit and at rest, to protect data. 
          </p>
          
          <h2 id="dataretention">Data Retention</h2>
          <p>
            We retain usage data and technical audit logs only for as long as necessary to fulfill the purposes of billing and legal compliance.
          </p>

          <h2 id="yourrights">Your Rights</h2>
          <p>
            You have the right to access, correct, or request the deletion of your account data. For requests, please <Link to={{ pathname: '/requestform/generalinquiry',  state: { from: history.location.pathname } }}><b>contact us</b></Link>.
          </p>

          <h2 id="policychanges">Changes to This Policy</h2>
          <p>We may update this policy. Any changes will be posted on this page with a new "Last Updated" date.</p>

          <h2 id="contactus">Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please <Link to={{ pathname: '/requestform/generalinquiry',  state: { from: history.location.pathname } }}><b>contact us</b></Link>.
          </p>
        </div>
      </div>
    );
  }
}

export default Provacy;